export const DESKTOP = 'DESKTOP'
export const TABLET = 'TABLET'
export const MOBILE = 'MOBILE'
